/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Get_In_TouchInputs */

const en_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get in touch`)
};

const es_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const de_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt aufnehmen`)
};

const zh_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const ar_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا`)
};

const fr_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous contacter`)
};

const vi_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ`)
};

const sw_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasiliana`)
};

const th_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนใจติดต่อ`)
};

const bs_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Javite nam se`)
};

const ja_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const ko_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

const pt_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em contato`)
};

const it_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contattaci`)
};

const sv_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta oss`)
};

const nl_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem contact op`)
};

const da_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const nb_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta kontakt`)
};

const fi_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä`)
};

const pl_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skontaktuj się z nami`)
};

const ru_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свяжитесь с нами`)
};

const tr_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişime geçin`)
};

const hi_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क करें`)
};

const id_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

const ms_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

const cs_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte nás`)
};

const el_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε μαζί μας`)
};

const he_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו קשר`)
};

const af_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak ons`)
};

const hu_footer_get_in_touch = /** @type {(inputs: Footer_Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lépj kapcsolatba velünk`)
};

/**
* | output |
* | --- |
* | "Get in touch" |
*
* @param {Footer_Get_In_TouchInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_get_in_touch = /** @type {((inputs?: Footer_Get_In_TouchInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Get_In_TouchInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_get_in_touch(inputs)
	if (locale === "de") return de_footer_get_in_touch(inputs)
	if (locale === "zh") return zh_footer_get_in_touch(inputs)
	if (locale === "ar") return ar_footer_get_in_touch(inputs)
	if (locale === "fr") return fr_footer_get_in_touch(inputs)
	if (locale === "vi") return vi_footer_get_in_touch(inputs)
	if (locale === "sw") return sw_footer_get_in_touch(inputs)
	if (locale === "th") return th_footer_get_in_touch(inputs)
	if (locale === "bs") return bs_footer_get_in_touch(inputs)
	if (locale === "ja") return ja_footer_get_in_touch(inputs)
	if (locale === "ko") return ko_footer_get_in_touch(inputs)
	if (locale === "pt") return pt_footer_get_in_touch(inputs)
	if (locale === "it") return it_footer_get_in_touch(inputs)
	if (locale === "sv") return sv_footer_get_in_touch(inputs)
	if (locale === "nl") return nl_footer_get_in_touch(inputs)
	if (locale === "da") return da_footer_get_in_touch(inputs)
	if (locale === "nb") return nb_footer_get_in_touch(inputs)
	if (locale === "fi") return fi_footer_get_in_touch(inputs)
	if (locale === "pl") return pl_footer_get_in_touch(inputs)
	if (locale === "ru") return ru_footer_get_in_touch(inputs)
	if (locale === "tr") return tr_footer_get_in_touch(inputs)
	if (locale === "hi") return hi_footer_get_in_touch(inputs)
	if (locale === "id") return id_footer_get_in_touch(inputs)
	if (locale === "ms") return ms_footer_get_in_touch(inputs)
	if (locale === "cs") return cs_footer_get_in_touch(inputs)
	if (locale === "el") return el_footer_get_in_touch(inputs)
	if (locale === "he") return he_footer_get_in_touch(inputs)
	if (locale === "af") return af_footer_get_in_touch(inputs)
	if (locale === "hu") return hu_footer_get_in_touch(inputs)
	return en_footer_get_in_touch(inputs)
});